// src/services/ApiRoutes.ts

/**
 * Enum for managing API routes.
 * This helps avoid hardcoding the routes in multiple places.
 */
export enum ApiRoutes {
  LOGIN = "/api/v1/franchise/login",
  VERIFY_OTP = "/api/v1/franchise/login/verify-otp",
  PASSWORD_RESET = "/api/v1/franchise/request-temporary-password",
  TERMINAL_DETAILS = "/api/v1/franchise/terminal",
  CREATE_MEMBER = "/api/v1/franchise/create-user",
  UPDATE_MEMBER = "/api/v1/franchise/update-user",
  UPDATE_TERMINAL = "/api/v1/franchise/update-terminal",
  CHANGE_PASSWORD = "/api/v1/franchise/update-password",
  LOGOUT = "/api/v1/franchise/logout",
  VENDOR_CODE = "/api/v1/franchise/create-vendor-code",
  VENDOR_PRODUCTS = "/api/v1/franchise/vendor-products",
  FRANCHISE_USER = "/api/v1/franchise/users",
  META_DATA = "/api/v1/franchise/metadata",
  ORDER_DETAILES = "/api/v1/franchise/orders",
  DOWNLOAD_ORDERS = "/api/v1/franchise/orders/download",
}